import { makeStyles } from '@material-ui/core/styles';
import React from 'react';

const useEmptyMessageStyles = makeStyles(
  (muiTheme) => ({
    root: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      padding: muiTheme.spacing(14, 4),
    },
  }),
  { name: 'EmptyMessage' },
);

const EmptyMessage = ({
  message = 'Sorry, we couldn’t find any results',
}: {
  message?: string;
}) => {
  const classes = useEmptyMessageStyles();

  return <div className={classes.root}>{message}</div>;
};

export default EmptyMessage;
